// import { ENV } from './environment'

let apiBase = 'https://api.clubhub.it/'

// if (!ENV.production) {
//   apiBase = 'http://127.0.0.1/cmapi/'
// }
if (window.location.hostname.indexOf('192.168') > -1) {
  apiBase = 'http://' + window.location.hostname + '/cmapi/'
}

export const URIS = {
  apiBase,
  login: apiBase + 'login',
  club: apiBase + 'club',
  members: apiBase + 'members',
  courses: apiBase + 'courses',
  instructors: apiBase + 'instructors',
  receipts: apiBase + 'receipts',
  pdf: apiBase + 'pdf',
  doc: apiBase + 'doc',
  balance: apiBase + 'balance',
  fiscalyear: apiBase + 'fiscalyear',
  attendances: apiBase + 'attendances',
  dashboard: apiBase + 'dashboard',
  notes: apiBase + 'notes',
  version: apiBase + 'version',
  export: apiBase + 'export',
  exportFolder: apiBase + 'tmp',
  axiosHeaders: {
    'Content-Type': 'application/json'
  }
}

export function loadHeaders() {
  return {
    'X-Bearer': window.localStorage['it.clubhub.bearer'],
    'X-Time': window.localStorage['it.clubhub.time'],
    'X-Email': window.localStorage['it.clubhub.email'],
    'X-Grant': window.localStorage['it.clubhub.grant'],
    'X-Club': window.localStorage['it.clubhub.club'],
    'X-Userid': window.localStorage['it.clubhub.userid'],
    'X-Fiscalyear': window.localStorage['it.clubhub.fiscalyear'],
    'Content-Type': 'application/json'
  }
}



// WEBPACK FOOTER //
// ./src/Uris.js